import {getProductList, getProductListColConfig} from '@/services/ProductsService/product'
import {useQueries} from '@tanstack/react-query'

export const useProductList = () => {
  const results = useQueries({
    queries: [
      {queryKey: ['PRODUCT_LIST'], queryFn: getProductList},
      {queryKey: ['PRODUCT_LIST_COL_CONFIG'], queryFn: getProductListColConfig},
    ],
  })

  return {
    productListData: results?.[0]?.data || {},
    productListColConfigData: results?.[1]?.data || [],
  }
}
